import { takeLatest, all, put, call } from 'redux-saga/effects'
import * as actions from './actions'
import axios from 'portal/utils/axios-msal'

function* projectsGetSaga(action) {
    yield put(actions.projectsGetStart())
    if (action.accountId === '' || action.accountId === null) {
        yield put(actions.projectsGetFail('No Account Id was set'))
    }
    try {
        const response = yield call(
            axios.get,
            '/accounts/' + action.accountId + '/projects/'
        )
        yield put(actions.projectsGetSuccess(response.data))
    } catch (error) {
        yield put(actions.projectsGetFail(error))
    }
}

export function* watch() {
    yield all([takeLatest(actions.PROJS_GET_SAGA, projectsGetSaga)])
}